import { type WorkContentAlbum } from "@clientFrontend/features/publication/type/type";
import { type FC, memo, useCallback } from "react";

/* サーバーにパラメーターを送る際に、削除予定の画像のIDも送る。サーバー側では以下URLに処理が到達し、削除される。 */
/* https://github.com/rejob/rejob-v2/blob/0677ef662eba0820f45be00c73a41b9fb5c7f98e/app/models/work_content.rb#L1092-L1097 */
/* stateで削除されたalbumを管理するのは複雑になる。また、サーバーサイドの仕組みを変更すると大掛かりな修正が必要なので今はこの実装にする */

type DeletedAlbumParamsBuilder = {
  initialWorkContentAlbums: WorkContentAlbum[];
  selectedWorkContentAlbums: WorkContentAlbum[];
};

const DeletedAlbumParamsBuilderComponent: FC<DeletedAlbumParamsBuilder> = ({
  initialWorkContentAlbums,
  selectedWorkContentAlbums,
}) => {
  const calcDeletedAlbums = useCallback((): WorkContentAlbum[] => {
    const selectedWorkContentAlbumIds = new Set(selectedWorkContentAlbums.map((album) => album.id));
    return initialWorkContentAlbums.filter((album) => !selectedWorkContentAlbumIds.has(album.id));
  }, [initialWorkContentAlbums, selectedWorkContentAlbums]);

  const deletedAlbums = calcDeletedAlbums();
  if (!deletedAlbums.length) return <></>;

  return (
    <>
      {deletedAlbums.map((workContentAlbum, index) => {
        const paramsName = `work[work_contents_attributes][0][album_work_content_albums_attributes][${
          selectedWorkContentAlbums.length + index
        }]`;

        return (
          // workContentAlbumのidはあるが、clientImageIdがないものは削除対象になるので、IDだけ送って削除させる
          /* https://github.com/rejob/rejob-v2/blob/0677ef662eba0820f45be00c73a41b9fb5c7f98e/app/models/work_content.rb#L1092-L1097 */
          <input
            key={workContentAlbum.id || `new-${index}`}
            type="hidden"
            name={`${paramsName}[id]`}
            value={workContentAlbum.id || ""}
          />
        );
      })}
    </>
  );
};

export const DeletedAlbumParamsBuilder = memo(DeletedAlbumParamsBuilderComponent);
